import { render, staticRenderFns } from "./RestaurantLogoDisplay.vue?vue&type=template&id=23191e35&scoped=true&"
import script from "./RestaurantLogoDisplay.vue?vue&type=script&lang=js&"
export * from "./RestaurantLogoDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23191e35",
  null
  
)

export default component.exports